import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, AiMessageDto, DynamicFormDto, DynamicPayloadDto, MemberDto } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpAiAssistantService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/ai-assistant', authService);
	}
	public chat(message: AiMessageDto): Observable<AiMessageDto> {
		return super.doPost(true, `/${this.getBrowserRef()}/chat`,message);
	}
	// public get(id: number): Observable<DynamicFormDto> {
	// 	return super.doGet(true, `/${id}`);
	// }
	// public getFull(id: number): Observable<MemberDto> {
	// 	return super.doGet(true, `/${id}/full`);
	// }
	// public create(payload: DynamicPayloadDto): Observable<DynamicFormDto> {
	// 	return super.doPost(true, `/`, payload);
	// }
	// public edit(id: number, payload: DynamicPayloadDto): Observable<DynamicFormDto> {
	// 	return super.doPost(true, `/${id}`, payload);
	// }
	// public getAll(): Observable<MemberDto[]> {
	// 	return super.doGet(true, "/");
	// }

	private getBrowserRef(): string {
		const key = 'poh-browser-ref';
		let out = sessionStorage.getItem(key);
		if (out) {
			return out;
		}
		if (window.crypto && 'randomUUID' in window.crypto) {
			out = crypto.randomUUID();
		} else {
			out = Math.random().toString(36).slice(2) + Date.now().toString(36);
		}
		sessionStorage.setItem(key, out);
		return out;
	}
}
